import $ from 'jquery';

window.toggleBio = function toggleBio() {
  $('.bio-box').each(function() {
    const bio = $(this).parent().next();
    $(this).removeClass('active');
    $(bio).hide();
  })

  $('.bio-box').on("click", function(){
    const bio = $(this).parent().next();
    if ($(bio).is(':visible')) {
      $(this).removeClass('active');
      $(bio).hide();
    } else {
      $('.bio-box').removeClass('active');
      $('.bio-expanded').hide();
      $(this).addClass('active');
      $(bio).show();
    }
  });
}

function resizeBios(section) {
  $(section).find('.bio').css('height', '');
  var maxHeight = -1;
  $(section).find('.bio').each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  $(section).find('.bio').each(function() {
    $(this).height(maxHeight);
  });
}

window.uniformBios = function uniformBios() {
  $(document).ready(function() {
    resizeBios($('.card-collapse:visible'));
  });
  $(window).on('load', function() {
    resizeBios($('.card-collapse:visible'));
  });
  $(window).on('resize', function(){
    resizeBios($('.card-collapse:visible'));
  });
  document.querySelectorAll('.card-collapse').forEach((collapseEl) => {
    collapseEl.addEventListener('shown.bs.collapse', () => {
      resizeBios(collapseEl);
    });
  });
}
